var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPrompt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5661 1.35484C11.2795 1.35484 11.0049 1.46848 10.8026 1.67034L10.2293 2.24249L11.7544 3.7645L12.3296 3.19043C12.5318 2.98862 12.6452 2.7152 12.6452 2.43039C12.6452 2.14557 12.5318 1.87215 12.3296 1.67034C12.1273 1.46848 11.8527 1.35484 11.5661 1.35484ZM10.7954 4.72156L9.27035 3.19955L1.35484 11.0993V12.6452H2.85596L10.7954 4.72156ZM9.84557 0.711365C10.3021 0.25573 10.921 0 11.5661 0C12.2112 0 12.8301 0.25573 13.2867 0.711365C13.7432 1.16705 14 1.78537 14 2.43039C14 3.0754 13.7432 3.69372 13.2867 4.14941L3.61468 13.8021C3.48768 13.9288 3.31558 14 3.13616 14H0.677419C0.303291 14 0 13.6967 0 13.3226V10.8183C0 10.6384 0.0715567 10.4659 0.19889 10.3388L9.84557 0.711365Z",
    fill: "#D52377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPrompt);
export default __webpack_public_path__ + "static/media/edit_prompt.d1c1676f5c2e68bb62c774b3e056bc64.svg";
export { ForwardRef as ReactComponent };